var _linearGradient, _circle, _circle2, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127 127"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fp_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: 18.598,
    y1: 108.404,
    x2: 108.402,
    y2: 18.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3cb883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109,
    stopColor: "#5bc397"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278,
    stopColor: "#86d3b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#a0dcc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#aae0c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567,
    stopColor: "#a3ddc5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683,
    stopColor: "#90d6b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#70cba4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#4b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cb883"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 63.5,
    r: 63.5,
    fill: "url(#fp_svg__a)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 63.5,
    r: 44.2,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.3 88.3v-5.8c-4.1-.2-8.1-1.3-10.4-2.6l1.8-7.2c2.6 1.4 6.2 2.7 10.2 2.7 3.5 0 5.9-1.3 5.9-3.8 0-2.3-2-3.8-6.5-5.3-6.6-2.2-11-5.3-11-11.2 0-5.4 3.8-9.6 10.4-10.9v-5.8h6v5.4c4.1.2 6.9 1 8.9 2l-1.8 6.9c-1.6-.7-4.4-2.1-8.8-2.1-4 0-5.3 1.7-5.3 3.4 0 2 2.1 3.3 7.4 5.3 7.3 2.6 10.2 5.9 10.2 11.5 0 5.5-3.9 10.1-10.9 11.3v6.2h-6.1z",
    fill: "#404040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5 107.7c-11.1 0-21.8-4.2-30-11.7l3.4-3.7c7.3 6.7 16.7 10.4 26.6 10.4 21.6 0 39.2-17.6 39.2-39.2S85.1 24.3 63.5 24.3v-5c24.4 0 44.2 19.8 44.2 44.2s-19.8 44.2-44.2 44.2z",
    fill: "#cf2437"
  })));
}

export default SvgFp;